import { GenericModalTypes } from './GenericModalWithIconContentTypes';
var GenericModalWithIconContent = require('./GenericModalWithIconContent').GenericModalWithIconContent;
export { GenericModalWithIconContent, GenericModalTypes };
